import { NotFoundIcon } from '../$portalId/-components/assets/not-found-icon';
import { Footer } from '../$portalId/-components/footer';
import { Header } from '../$portalId/-components/header';
import { DivWithPrimaryColorVariable } from '../$portalId/-components/div-with-primary-color-variable';
import { ErrorBoundary } from 'react-error-boundary';
import { NotFoundSeo } from './not-found-seo';

export function NotFound() {
	return (
		<>
			{/* Above the boundary: the portal-less fallback needs the title and `noindex` too. */}
			<NotFoundSeo />

			{/* Without a portal for this subdomain the page fails, so a plain 404 renders instead. */}
			<ErrorBoundary
				fallback={
					<main className="m-auto flex max-w-[1366px] justify-center gap-6 px-12 py-24 lg:gap-12">
						<div className="flex flex-col items-center justify-center gap-6 p-6">
							<NotFoundIcon className="text-primary" />
							<h1 className="text-primary/70 text-4xl font-bold">404</h1>
						</div>
					</main>
				}
			>
				<Header />

				<main className="m-auto flex max-w-[1366px] justify-center gap-6 px-12 py-24 lg:gap-12">
					<DivWithPrimaryColorVariable className="flex flex-col items-center justify-center gap-6 p-6">
						<NotFoundIcon className="text-primary" />
						<h1 className="text-primary/70 text-4xl font-bold">404</h1>
					</DivWithPrimaryColorVariable>
				</main>

				<Footer />
			</ErrorBoundary>
		</>
	);
}
